<template>
  <b-modal ref="PriceEditingModal" :title="$t('modal_dialogs.price_editing.title')" :no-close-on-backdrop="true"
           :no-enforce-focus="true">
    <div>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.start_date')}}</label>
          <datepicker v-model="priceData.start_date"
                      lang="en"
                      :width="170"
                      :first-day-of-week="1"
                      :disabled="Boolean(this.operationId)"
                      placeholder=""
          ></datepicker>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.end_date')}}</label>
          <datepicker v-model="priceData.end_date"
                      lang="en"
                      :width="170"
                      :first-day-of-week="1"
                      :disabled="Boolean(this.operationId)"
                      placeholder=""
          ></datepicker>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.package_nr')}}</label>
          <input class="form-control" v-model="priceData.package_nr">
        </b-col>
        <b-col>
          <label>{{$t('labels.pellets.diameter')}}</label>
          <multiselect v-model="priceData.diameters" :max-height="200" :searchable="true"
                       placeholder="Choose diameter" :multiple="true" :close-on-select="false"
                       label="name" track-by="name" :options="pellet_diameters"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.group')}}</label>
          <options-toggle-multiselect :data.sync="priceData.groups" :options="groups">
            <multiselect v-model="priceData.groups" :max-height="200" :searchable="true"
                         label="name" track-by="name" :options="groups"
                         :multiple="true" :close-on-select="false"
                         placeholder=""
            ></multiselect>
          </options-toggle-multiselect>
        </b-col>
        <b-col>
          <label>{{$t('labels.pellets.pallet_size')}}</label>
          <multiselect v-model="priceData.pallet_sizes" :max-height="200" :searchable="true"
                       placeholder="Choose pallet size" :multiple="true" :close-on-select="false"
                       label="name" track-by="name" :options="pallet_sizes"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.wood')}}</label>
          <options-toggle-multiselect :data.sync="priceData.trees" :options="wood">
            <multiselect v-model="priceData.trees" :max-height="200" :searchable="true"
                         label="name" track-by="name" :options="wood"
                         :multiple="true" :close-on-select="false"
                         placeholder=""
            ></multiselect>
          </options-toggle-multiselect>
        </b-col>
        <b-col title="For setting range value of unit weight enter value with - separator. For example 50 - 100">
          <label>
            {{$t('labels.pellets.unit_weight')}}</label>
          <input class="form-control" v-model="priceData.unit_weight" min="0">
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.quality')}}</label>
          <options-toggle-multiselect :data.sync="priceData.qualities" :options="qualities_list">
            <multiselect v-model="priceData.qualities" :max-height="200" :searchable="true"
                         label="name" track-by="name" :options="qualities_list"
                         :multiple="true" :close-on-select="false"
                         placeholder=""
            ></multiselect>
          </options-toggle-multiselect>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.price')}}</label>
          <input type="number" class="form-control" v-model="priceData.price"
                 :class="{ required: !priceData.price && !priceData.whole_price}">
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.pellets.bag_logo')}}</label>
          <multiselect v-model="priceData.bag_logos" :max-height="200" :searchable="true"
                       placeholder="Choose bag logo" label="name" track-by="name"
                       :options="bag_logos" :multiple="true" :close-on-select="false"
          />
        </b-col>
        <b-col>
          <label>{{$t('modal_dialogs.price_editing.metric_type')}}</label>
          <multiselect v-model="priceData.metric_type" :max-height="200" :searchable="true"
                       label="name" track-by="name"
                       :class="{ required: !priceData.metric_type && !priceData.whole_price}"
                       :options="metric_types" :allow-empty="false"></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <label>{{$t('labels.common.stock')}}</label>
          <multiselect v-model="priceData.stock_addresses" :max-height="200"
                       placeholder="" label="name" track-by="id"
                       :options="stock_addresses" :multiple="true"
                       :close-on-select="false"
                       select-label="" deselect-label="" selected-label=""></multiselect>
        </b-col>
        <b-col cols="6" v-if="operationId && !priceData.isCreatePriceToPackage">
          <label>{{$t('labels.common.whole_cost')}}</label>
          <input type="number" class="form-control"
                 :class="{ required: !priceData.whole_price && (!priceData.price || !priceData.metric_type)}"
                 v-model="priceData.whole_price">
        </b-col>
      </b-row>
      <b-row v-if="operationId && priceData.isCreatePriceToPackage">
        <b-col>
          <label>t</label>
          <input type="number" class="form-control" v-model="priceData.weight" disabled>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.whole_cost')}}</label>
          <input type="number" class="form-control" v-model="priceData.whole_price">
        </b-col>
      </b-row>
    </div>
    <div slot="modal-footer" class="w-100 text-center">
      <b-btn size="sm" variant="success" @click="savePrice">
        {{$t('buttons.common.save')}}
      </b-btn>
      <b-btn size="sm" variant="outline-success" @click="saveAndMore">
        {{$t('buttons.common.save_add_more')}}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
  import { mapState } from 'vuex';
  import Multiselect from 'vue-multiselect';
  import Datepicker from 'vue2-datepicker';
  import moment from 'moment';
  import { handlerResponse, setNotifyData, getArrayByProperty } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import OptionsToggleMultiselect from '@/components/common/OptionsToggleMultiselect';
  import { DATE_FORMAT } from '@/constants';

  export default {
    props: ['operationId', 'fetchCallback'],
    components: {
      Multiselect,
      Datepicker,
      OptionsToggleMultiselect
    },
    data() {
      return {
        type: null,
        initialPriceData: {
          start_date: null,
          end_date: null,
          package_nr: null,
          diameters: [],
          groups: [],
          pallet_sizes: [],
          trees: [],
          unit_weight: [],
          qualities: [],
          price: 0,
          bag_logos: [],
          weight: 0,
          cost: 0,
          metric_type: {key: 'tonne', name: 't'},
          whole_price: 0,
          impr: null,
          stock_addresses: []
        },
        priceData: {},
        additionalData: null,
        metric_types: [
          {key: 'tonne', name: 't'}
        ]
      }
    },
    methods: {
      async savePrice() {
        const savedData = this.prepareSavedData();
        const loader = this.$loading.show();
        if (!this.priceData.isNew) {
          await this.$http.put(`woodware/prices/${this.type}/${this.priceData.id}/`, savedData)
            .then(handlerResponse).then(() => {
              if (this.type === 'fixed_prices') {
                this.$notify(setNotifyData(this.$i18n.t(`notifications.common.success`),
                  this.$i18n.t(`notifications.prices.fixed_price_updated`), 'success'));
                this.loadPrices('fixed_prices');
              } else {
                this.$notify(setNotifyData(this.$i18n.t(`notifications.common.success`),
                  this.$i18n.t(`notifications.prices.operation_cost_updated`), 'success'));
                this.loadPrices('process_prices');
              }
              this.$refs['PriceEditingModal'].hide();
            }).catch(error => {
              notificationsRenderer(error.data, 'error');
            }).finally(() => {
              loader.hide();
            });
        } else {
          await this.$http.post(`woodware/prices/${this.type}/`, savedData).then(handlerResponse).then(() => {
            if (this.type === 'fixed_prices') {
              this.$notify(setNotifyData(this.$i18n.t(`notifications.common.success`),
                this.$i18n.t(`notifications.prices.fixed_price_created`), 'success'));
              this.loadPrices('fixed_prices');
            } else {
              this.$notify(setNotifyData(this.$i18n.t(`notifications.common.success`),
                this.$i18n.t(`notifications.prices.operation_cost_created`), 'success'));
              this.loadPrices('process_prices');
            }
            this.$refs['PriceEditingModal'].hide();
          }).catch(error => {
            notificationsRenderer(error.data, 'error')
          }).finally(() => {
            loader.hide();
          });
        }
      },
      async saveAndMore() {
        try {
          await this.savePrice();
          this.$refs['PriceEditingModal'].show();
          delete this.priceData.id;
          this.priceData.isNew = true;
          this.priceData.start_date = null;
          this.priceData.end_date = null;
          this.priceData.metric_type = {key: 'tonne', name: 't'};
          this.priceData.price = 0;
          this.priceData.whole_price = 0;
        } catch (e) {
          console.log(e);
        }
      },
      loadPrices(priceType) {
        if (priceType === 'fixed_prices') {
          if (!this.operationId) {
            this.$store.dispatch('woodware/loadFixedPrices', this.additionalData);
          } else {
            this.$store.dispatch('operation/loadFixedPrices', this.operationId);
            this.fetchCallback();
          }
        } else {
          if (!this.operationId) {
            this.$store.dispatch('woodware/loadProcessPrices', this.additionalData);
          } else {
            this.$store.dispatch('operation/loadOperationCosts', this.operationId);
            this.fetchCallback();
          }
        }
      },
      prepareSavedData() {
        return {
          start_date: this.priceData.start_date ? moment(this.priceData.start_date).format(DATE_FORMAT) : null,
          end_date: this.priceData.end_date ? moment(this.priceData.end_date).format(DATE_FORMAT) : null,
          diameters: getArrayByProperty(this.priceData.diameters, 'id'),
          pallet_sizes: getArrayByProperty(this.priceData.pallet_sizes, 'id'),
          bag_logos: getArrayByProperty(this.priceData.bag_logos, 'id'),
          unit_weight: this.createRangeParam(this.priceData.unit_weight),
          package_nr: this.priceData.package_nr,
          trees: getArrayByProperty(this.priceData.trees, 'id'),
          qualities: getArrayByProperty(this.priceData.qualities, 'id'),
          groups: getArrayByProperty(this.priceData.groups, 'id'),
          price: this.priceData.price,
          whole_price: this.priceData.whole_price,
          metric_type: this.priceData.metric_type && this.priceData.metric_type.key,
          process: this.additionalData.process,
          movement: this.operationId,
          stock_addresses: getArrayByProperty(this.priceData.stock_addresses, 'id')
        }
      },
      createRangeParam(value) {
        const paramsValue = value && value.toString();
        if (value) {
          const startValue = paramsValue.split('-')[0], endValue = paramsValue.split('-')[1] || startValue;
          return [Number(startValue.trim()), Number(endValue.trim())];
        }
        return null;
      }
    },
    computed: {
      ...mapState('woodware', ['wood', 'qualities_list', 'groups', 'pallet_sizes', 'bag_logos', 'pellet_diameters', 'stock_addresses'])
    },
    beforeMount() {
      this.$root.$on('openPriceEditingModal', (data) => {
        this.priceData = {...this.initialPriceData};
        this.additionalData = data.additionalPriceData;
        this.type = data.type;
        this.priceData = {...this.priceData, ...data.priceData};
        if (this.$refs['PriceEditingModal']) {
          this.$store.cache.dispatch('woodware/getWood');
          this.$store.cache.dispatch('woodware/getQualitiesList');
          this.$store.cache.dispatch('woodware/fetchPalletSizes');
          this.$store.cache.dispatch('woodware/fetchBagLogos');
          this.$store.cache.dispatch('woodware/fetchPelletDiameters');
          this.$store.cache.dispatch('woodware/getGroupsWithHierarchy');
          this.$store.cache.dispatch('woodware/getStockAddresses');
          this.$refs['PriceEditingModal'].show();
        }
      });
    },
    beforeDestroy() {
      this.$root.$off('openPriceEditingModal');
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modals/PriceEditingModal.vue